const doc = [({"payment_methods":({"reseller":({"select_payment":"اختر طريقة الدفع"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;